import { createStore } from "vuex";
import axios from 'axios';
import api from '../api';

export default createStore({
  state: {
    jury: null,
    juryToken: localStorage.getItem('jury_token') || null,
    juryPermissions: JSON.parse(localStorage.getItem('jury_permissions') || '[]'),
    candidates: [],
    selectedCandidate: null,
    criteriasByCategory: [],
    locale: localStorage.getItem('user_locale') || 'fr',
  },
  mutations: {
    setJury(state, jury) {
      state.jury = jury;
    },
    setJuryToken(state, token) {
      state.juryToken = token;
      if (token) {
        localStorage.setItem('jury_token', token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } else {
        localStorage.removeItem('jury_token');
        delete axios.defaults.headers.common['Authorization'];
      }
    },
    setJuryPermissions(state, permissions) {
      state.juryPermissions = permissions || [];
      localStorage.setItem('jury_permissions', JSON.stringify(state.juryPermissions));
    },
    setCandidates(state, candidates) {
      state.candidates = candidates;
    },
    setSelectedCandidate(state, candidate) {
      state.selectedCandidate = candidate;
    },
    setCriteriasByCategory(state, criterias) {
      state.criteriasByCategory = criterias;
    },
    setLocale(state, locale) {
      state.locale = locale;
      localStorage.setItem('user_locale', locale);
    },
  },
  actions: {
    updateJury({ commit }, jury) {
      commit('setJury', jury);
    },
    updateJuryToken({ commit }, token) {
      commit('setJuryToken', token);
    },
    updateJuryPermissions({ commit }, permissions) {
      commit('setJuryPermissions', permissions);
    },
    updateCandidates({ commit }, candidates) {
      commit('setCandidates', candidates);
    },
    updateSelectedCandidate({ commit }, candidate) {
      commit('setSelectedCandidate', candidate);
    },
    updateCriteriasByCategory({ commit }, criterias) {
      commit('setCriteriasByCategory', criterias);
    },
    updateLocale({ commit }, locale) {
      commit('setLocale', locale);
    },
    async restoreSession({ commit, state }) {
      const token = state.juryToken;
      if (!token) return false;

      try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const response = await axios.get(api.juryMe);
        if (response.data.success) {
          commit('setJury', response.data.data);
          commit('setJuryPermissions', response.data.permissions || []);
          return true;
        } else {
          commit('setJuryToken', null);
          commit('setJury', null);
          commit('setJuryPermissions', []);
          return false;
        }
      } catch (error) {
        commit('setJuryToken', null);
        commit('setJury', null);
        commit('setJuryPermissions', []);
        return false;
      }
    },
    logout({ commit }) {
      commit('setJury', null);
      commit('setJuryToken', null);
      commit('setJuryPermissions', []);
      commit('setSelectedCandidate', null);
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.juryToken,
    currentJury: (state) => state.jury,
    hasPermission: (state) => (permission) => state.juryPermissions.includes(permission),
    canAddMonthlyData: (state) => state.juryPermissions.includes('add_monthly_data'),
    canAddPitchData: (state) => state.juryPermissions.includes('add_pitch_data'),
    canViewLeaderboard: (state) => state.juryPermissions.length > 0,
  },
});